module.exports = __webpack_public_path__ + "static/media/curling-iron.870bd676.svg";